import { customSeriesDefaultOptions, CustomSeriesOptions } from 'lightweight-charts'
import { baselineTopFillColor1, baselineTopFillColor2, buyColor } from '../../../../assets/colors'
import { SeriesSourceOptions } from '../../chart.typings'

export type BaselineSeriesOptions = CustomSeriesOptions & SeriesSourceOptions & {
    baseValue: number,
    topLineColor: string,
    topFillColor1: string,
    topFillColor2: string,
    bottomLineColor: string,
    bottomFillColor1: string,
    bottomFillColor2: string
    /** Stroke width in CSS pixels (multiplied by devicePixelRatio in the renderer). */
    lineWidth?: number
}

export const defaultOptions: BaselineSeriesOptions = {
    ...customSeriesDefaultOptions,
    source: "close",
    baseValue: 50,
    lineWidth: 2,
    topLineColor: buyColor,
    bottomLineColor: '#f23645',
    topFillColor1: baselineTopFillColor1,
    topFillColor2: baselineTopFillColor2,
    bottomFillColor1: '#f2364500',
    bottomFillColor2: '#f2364547',
}
